import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { FormBuilder, Validators } from '@angular/forms';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { MembershipService } from '@app/services/membership.service';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { Subscription } from 'rxjs';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-terminatemembershipcamp',
  templateUrl: './terminatemembershipcamp.component.html',
  styleUrls: ['./terminatemembershipcamp.component.css']
})

export class TerminatemembershipcampComponent implements OnInit, OnChanges, OnDestroy {

  @Input() memberid: number;
  @Input() givenname: string;
  @Input() familyname: string;
  @Output() closeTerminateCamp: EventEmitter<any> = new EventEmitter();

  camps;
  terminatemembershipcampform;
  
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private institutionsService: InstitutionsService,
    private membershipService: MembershipService,
    private snackbarService: SnackbarService,
    private confirmationService: ConfirmationService) { }

  ngOnChanges(_: SimpleChanges) {
    if (_ && this.terminatemembershipcampform) {
    this.terminatemembershipcampform.get('memberId').setValue(this.memberid.toString());
    this.ngOnInit();
    }
  }

  ngOnInit() {
    this.terminatemembershipcampform = this.fb.group({
      memberId: ['', ''],
      institutionId: ['', Validators.required],
      fromDate: ['', Validators.required],
      gott: ['', Validators.required],
      action: ['update', '']
    });
    
    if (this.memberid > 0) {
      this.subscriptions.push(this.institutionsService.GetCurrentCampOrAssociationsByMemberIdAsync(+this.memberid).subscribe(response => {
        if (response) {
          this.camps = response;
        }
      }));
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  close() {
    this.closeTerminateCamp.emit();
  }

  save() {
    const data = {
      memberId: this.memberid,
      institutionId: this.terminatemembershipcampform.get('institutionId').value,
      causeId: this.terminatemembershipcampform.get('gott').value,
      date: this.terminatemembershipcampform.get('fromDate').value
    };
    this.subscriptions.push(this.membershipService.EndMemberMembership(data).subscribe(response => {
      this.snackbarService.openSnackBar(response, null);
      this.close();
    }));
  }

  confirmDialog(): void {
      this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du avsluta medlemskapet?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
        this.save();
      },
      reject: () => {
      }
    });
  }
}
